/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineIdFoldersFolderid202,
  PutApiV1ClassroomdisciplineIdFoldersFolderid400,
  PutApiV1ClassroomdisciplineIdFoldersFolderid401,
  PutApiV1ClassroomdisciplineIdFoldersFolderid404,
  PutApiV1ClassroomdisciplineIdFoldersFolderidMutationRequest,
  PutApiV1ClassroomdisciplineIdFoldersFolderidMutationResponse,
  PutApiV1ClassroomdisciplineIdFoldersFolderidPathParams,
} from "../../types/classPlanningMaterialController/PutApiV1ClassroomdisciplineIdFoldersFolderid.ts";
import { upsertClassroomDisFolderViewModelSchema } from "../upsertClassroomDisFolderViewModelSchema.ts";

export const putApiV1ClassroomdisciplineIdFoldersFolderidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    folderId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1ClassroomdisciplineIdFoldersFolderidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineIdFoldersFolderid202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdFoldersFolderid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineIdFoldersFolderid400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdFoldersFolderid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineIdFoldersFolderid401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdFoldersFolderid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineIdFoldersFolderid404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdFoldersFolderid404>;

export const putApiV1ClassroomdisciplineIdFoldersFolderidMutationRequestSchema =
  z.lazy(
    () => upsertClassroomDisFolderViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdFoldersFolderidMutationRequest>;

export const putApiV1ClassroomdisciplineIdFoldersFolderidMutationResponseSchema =
  z.lazy(
    () => putApiV1ClassroomdisciplineIdFoldersFolderid202Schema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdFoldersFolderidMutationResponse>;
